<template>
  <div class="detail-contenter contenter">
    <div class="header">
      <div class="logocontain"><span class="logo" /></div>
      <div class="top-info">
        <div class="left-info">
          <span class="company" v-html="detail.company" :title="detail.company"></span>
          <p class="company-info" v-show="detail.description">
            <span style="font-weight: bold;">公司信息:</span>
            <span>
              {{detail.description}}
            </span>
          </p>
          <p>
            <a-tag color="#063359" style="color:#52718e;border-radius: 0;" v-if="!!detail.country">{{`${detail.country}`}}</a-tag>
            <a-tag color="#063359" style="color:#52718e;border-radius: 50px;" @click="attention">
              <a-icon type="heart" style="color:#ff6b6b;" :theme="isCollect&&'filled'||'outlined'" /> {{isCollect&&'已收藏'||'收藏'}}</a-tag>

          </p>
        </div>
        <div class="right-info">
          <p :class="{'notshow':(detail.linkcount==0)}">
            <span class="count" v-html="detail.linkcount"  v-show="detail.linkcount!=0"></span>
            <span class="data-type"  v-show="detail.linkcount!=0">联系人</span>
          </p>
          <p>
            <span class="count" v-html="detail.expocount"></span>
            <span class="data-type">参展次数</span>
          </p>
        </div>
      </div>
      <p class="tip" v-if="!!(accountInfo&&accountInfo.emailfinder)">
        <span>可搜索次数剩余<span :style="{color:true&&'red'}">{{accountInfo.emailfinder.end_time!='-1'?'不限':((($route.query.type==1||$route.query.type==2)?accountInfo.emailfinder.buy_purchaser_search_times:accountInfo.emailfinder.purchaser_search_times)||0)}}</span>次</span>
        <a-divider type="vertical" />
        <span>可查看数据剩余<span :style="{color:true&&'red'}">{{(($route.query.type==1||$route.query.type==2)?accountInfo.emailfinder.buy_purchaser_detail_times:accountInfo.emailfinder.purchaser_detail_times)||0}}</span>条</span>
      </p>
    </div>
    <div class="content">
      <a-tabs type="card">
        <a-tab-pane tab="企业信息" key="1">
          <s-company :detail="detail"></s-company>
        </a-tab-pane>
        <a-tab-pane tab="联系人" key="2" v-if="detail.linkcount!=0">
          <s-contact :detail="detail"></s-contact>
        </a-tab-pane>
        <a-tab-pane tab="参与展会" key="3">
          <s-exhibition :detail="detail"></s-exhibition>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import Company from "./_Company.vue";
import Contact from "./_Contact.vue";
import Exhibition from "./_Exhibition.vue";
export default {
  components: {
    "s-company":Company,
    "s-contact": Contact,
    "s-exhibition": Exhibition
  },
  data() {
    return {
      isCollect:false,
      detail: {}
    };
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    attention() {
      this.$http
        .post("/zzCollect", {
          is_collect: !this.isCollect + 0,
          pid: this.detail.id,
          type:"1,2".indexOf(this.$route.query.type)>-1?1:2
        })
        .then(res => {
          console.log(res)
          if (!res.error) {
            this.isCollect = !this.isCollect;
          }
        });
    }
  },
  created() {
    let html=document.createElement("div");
    this.$http
      .post("/zzGetPurchaserDetail", { 
        pid: this.$route.params.pid || 0 ,
        type:"1,2".indexOf(this.$route.query.type)>-1?1:2
        })
      .then(res => {
        console.log(res);
          if (!res.error) {
            if(!res.data.detail.company){
              this.$router.push({ path: "/" });
            }else{
              this.detail = res.data.detail;
              this.isCollect = this.detail.is_collect=="0"?false:true;

              html.innerHTML=this.detail.company;
              this.detail.company=html.innerText;
              html=null;

              document.title=this.detail&&this.detail.company||'';
              !this.detail.is_charge&&this.$notification.info({
                    message: "注意",
                    description: "本次查看不扣额度"
              });
              this.$refreshAccountInfo();
            }
        } else {
          this.$notification.info({
            message: "提醒",
            description: res.errorMsg
          });
        }
      })
      .catch(e => {
        this.$router.push({ path: "/" });
        this.$notification.error({
          message: "错误",
          description: e
        });
      });
  }
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.detail-contenter {
  background: #f9f9f9;
  .header {
    min-height: 330px;
    background: url("~@/assets/img/buyer_banner.jpg");
    text-align: left;
    .logocontain{
      margin: 0 auto;
      width: 1200px;
      height: 90px;
      .logo {
        display: inline-block;
        width: 200px;
        height: 70px;
        @include intop-icon;
        background-position: -40px -400px !important;
        margin: 15px 0 0 -10px;
      }
    }
    .tip {
      text-align: right;
      width: 1200px;
      margin: 40px auto 20px;
      color: #ffe79e;
      padding-right: 10px;
    }
    .top-info {
      width: 1200px;
      margin: 30px auto 0;
      display: flex;
      flex-flow: row;
      .left-info {
        // width: 800px;
        flex: 1;
        .company {
          font-size: 28px;
          color: #fff;
          word-break: break-all;
          display: inline-block;
          // height: 31px;
          // overflow: hidden;
          max-width: 700px;
          // text-overflow: ellipsis; /*文字隐藏以后添加省略号*/
          // white-space: nowrap; /*强制不换行*/
        }
        .company-info {
          display: flex;
          span {
            color: #7591ab;
            display: inline-block;
            &:first-child {
              width: 70px;
            }
            &:last-child {
              flex: 1;
              word-break: break-all;
            }
          }
          color: #52718e;
        }
        &>p:last-child{
          margin-top: 20px;
        }
      }
      .right-info {
        display: flex;
        flex-flow: row;
        width: 400px;
        p {
          width: 120px;
          height: 120px;
          border: 1px solid #182734;
          border-radius: 50%;
          background: #021423;
          font-size: 48px;
          color: #ffefbf;
          overflow: hidden;
          margin: auto;
          &.notshow{
            border: none;
          }
          .count {
            display: inline-block;
            text-align: center;
            width: 100%;
            margin-top: 10px;
          }
          .data-type {
            font-size: 14px;
            display: inline-block;
            height: 40px;
            width: 120px;
            vertical-align: top;
            text-align: center;
            border: 1px solid #082b49;
            border-radius: 100%;
            padding-top: 5px;
            color: #4d5e6b;
            background: #082b49;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" >
.detail-contenter {
  background: #fff;
  .ant-tabs {
    width: 1200px;
    margin: auto;
    margin-top: -45px;
  }
  .ant-tabs-bar {
    border-bottom: 6px solid #ff6b6b;
  }
  .ant-tabs-tab {
    background: #ffffff24 !important;
    color: #fff !important;
    height: 39px;
    border: none !important;
    border-radius: 0 !important;
    &:first-child {
      margin-left: 10px !important;
    }
  }
  .ant-tabs-tab-active {
    background: #ff6b6b !important;
    color: #fff !important;
  }
}
</style>
